import { useQuery } from '@tanstack/react-query'
import axios from '@pepper/utils/src/function/axiosInstance'
import { SEO_SERVICE_BASE_URL } from '@pepper/utils/src/api/config'
import { ApiError, GooglePropertyTypeGA } from '@pepper/utils/src/types/domain'

const handleFetch = async (companyId: string) => {
  const url = `${SEO_SERVICE_BASE_URL}/companies/${companyId}/integrations/ga/properties`
  const response = await axios.get(url)
  return response.data
}

export const useGaList = (companyId: string) => {
  const { data, error, isLoading } = useQuery<
    { data: GooglePropertyTypeGA[] },
    ApiError
  >({
    queryKey: ['ga', companyId],
    queryFn: () => handleFetch(companyId),
    enabled: !!companyId,
  })

  return {
    data,
    isLoading,
    error,
  }
}
